<template>
  <div class="orderlist-container" :style="wrapStyle">
    <div class="dog-wrap" v-if="showDog">
      <img class="dog-body" src="./images/dog.png" />
      <MathineList />
    </div>
    <div v-loading="loading" class="orderlistwrap">
      <div class="orderstab-wrap">
        <div class="orderstab" v-for="(item, index) in apps" :key="index">
          <div class="item" :class="{ selected: item?.group?.id == curGroup?.id }" @click="tabApps(index)">{{ item?.group?.name }}</div>
        </div>
      </div>
      <div class="orders" v-if="curApps?.length > 0">
        <template v-for="(_item, _index) in curApps" :key="_index">
          <div class="itemwrap">
            <div class="item" @click="$emit('config', { groupId: curGroup?.id, ..._item })">
              <div class="title">{{ _item?.name }}</div>
              <span class="desc">{{_item?.description || '-'}}</span>
              <div class="ctrl">开始执行<el-icon><DArrowRight /></el-icon></div>
            </div>
          </div>
        </template>
      </div>
      <Empty v-else />
    </div>
  </div>
</template>

<script setup>
  import {onMounted, ref} from 'vue'
  import { DArrowRight } from '@element-plus/icons-vue'
  // assets
  import * as Request from '@/assets/request';
  import * as CONST from '@/assets/const';
  // components
  import Empty from '@/components/empty';
  import MathineList from '@/pages/dispatch/components/mathinelist'

  /**
   * props
   */
  const props = defineProps({
    showDog: {
      type: Boolean,
      default: true
    },
    wrapStyle: {
      type: String,
      default: ''
    }
  })

  const curGroup = ref(null)
  const curApps = ref([])
  const apps = ref([])
  const loading = ref(false)
  const getApps = async () => {
    loading.value = true;
    const machinesResult = await Request.post({
      url: '/22001/facade/dispatch/machines'
    });
    loading.value = false;
    if(!machinesResult || machinesResult?.data?.length == 0) return;

    const machineIds = machinesResult.data.map(item => item.id);
    const result = await Request.post({
      url: '/22001/facade/dispatch/getAppByMachineIds',
      data: machineIds
    });
    if(result?.code != 200) return;

    if(result?.data?.apps?.length > 0) {
      apps.value = result?.data?.apps
      tabApps(0);
    }
  }
  const tabApps = (index) => {
    curApps.value = apps.value[index].apps;
    curGroup.value = apps.value[index].group || null;
  }
  onMounted(() => {
    getApps()
  })
</script>

<style scoped lang="less">
  @import "./index.less";
</style>
